import { supabase } from "./supabase";

// Pede à serverless que emita o Cartão CNPJ na Receita e anexe na ficha.
//
// Nunca bloqueia nada: a ficha já está salva quando isto roda. Se a Receita
// estiver fora, se acabarem os créditos ou se a chave não estiver configurada,
// o cartão volta a ser um documento a pedir — e o detalhe da ficha tem o botão
// para tentar de novo.
//
// `editToken` autentica pela ficha (fornecedor anônimo pelo link). Da equipe
// logada ele não é necessário.
export async function emitirCartaoCNPJ(fichaId, editToken) {
  const headers = { "Content-Type": "application/json" };
  if (!editToken) {
    const { data: { session } } = await supabase.auth.getSession();
    if (session?.access_token) headers.Authorization = `Bearer ${session.access_token}`;
  }
  try {
    const res = await fetch("/api/cnpj-comprovante", {
      method: "POST",
      headers,
      body: JSON.stringify({ ficha_id: fichaId, edit_token: editToken || undefined }),
    });
    const json = await res.json().catch(() => ({}));
    return res.ok ? json : { ok: false, erro: json.error || "Falha ao emitir o Cartão CNPJ." };
  } catch {
    return { ok: false, erro: "Falha ao emitir o Cartão CNPJ." };
  }
}
